import React, { useEffect, useMemo, useRef, useState } from "react";
import Select from "react-select";
import { formatInTimeZone } from "date-fns-tz";
import BarraPrincipal from "../Modulos/BarraPrincipal";
import {
    getCurrentTimeZone,
    getTimeZoneOptions,
    saveCurrentTimeZone,
} from "../utils/timezones";
import "./Css/myProfile.css";

const MyProfile = () => {
    const timezoneSectionRef = useRef(null);
    const timeZoneOptions = useMemo(() => getTimeZoneOptions(), []);
    const [selectedTimeZone, setSelectedTimeZone] = useState(getCurrentTimeZone);
    const [currentDateTime, setCurrentDateTime] = useState(() => new Date());

    const userInfo = {
        userName: localStorage.getItem("username") || "Usuario",
        email: "jmcastilla@example.com",
        avatar: "../assets/img/avatars/1.png",
        empresasAsociadas: ["Cargotronics", "Empresa Alpha", "Logistica Beta"],
        otherInfo: {
            role: "Administrador",
            joinedDate: "2022-01-15",
            status: "Activo",
        },
        notifications: [
            "Nueva tarea asignada.",
            "Revision requerida para el proyecto.",
            "Notificacion de sistema.",
        ],
    };

    const selectedTimeZoneOption = useMemo(
        () => timeZoneOptions.find((option) => option.value === selectedTimeZone) || null,
        [selectedTimeZone, timeZoneOptions]
    );

    const currentTimePreview = useMemo(() => {
        try {
            return formatInTimeZone(currentDateTime, selectedTimeZone, "yyyy-MM-dd HH:mm:ss (xxx)");
        } catch {
            return "No disponible";
        }
    }, [selectedTimeZone, currentDateTime]);

    const timezoneSelectStyles = useMemo(
        () => ({
            control: (provided, state) => ({
                ...provided,
                borderColor: state.isFocused ? "#67a6d1" : "#c8d8ee",
                boxShadow: state.isFocused ? "0 0 0 3px rgba(13, 107, 168, 0.14)" : "none",
                borderRadius: 10,
                minHeight: 44,
            }),
            option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected ? "#0d6ba8" : state.isFocused ? "#e8f4fc" : "#fff",
                color: state.isSelected ? "#fff" : "#1f2a44",
                fontSize: "0.9rem",
            }),
            placeholder: (provided) => ({
                ...provided,
                color: "#6b7280",
            }),
            menu: (provided) => ({
                ...provided,
                border: "1px solid #d2dfef",
                overflow: "hidden",
                boxShadow: "0 14px 24px rgba(31, 42, 68, 0.14)",
            }),
            singleValue: (provided) => ({
                ...provided,
                color: "#1f2a44",
            }),
        }),
        []
    );

    useEffect(() => {
        saveCurrentTimeZone(selectedTimeZone);
    }, [selectedTimeZone]);

    useEffect(() => {
        const timerId = window.setInterval(() => {
            setCurrentDateTime(new Date());
        }, 1000);

        return () => window.clearInterval(timerId);
    }, []);

    useEffect(() => {
        if (window.location.hash === "#timezone-settings" && timezoneSectionRef.current) {
            timezoneSectionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, []);

    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <div className="layout-page">
                    <BarraPrincipal />
                    <div className="profile-page">
                        <div className="profile-shell">
                            <section className="profile-hero">
                                <div className="profile-avatar-wrap">
                                    <img src={userInfo.avatar} alt="Avatar" className="profile-avatar" />
                                </div>

                                <div className="profile-main">
                                    <h1 className="profile-name">{userInfo.userName}</h1>
                                    <p className="profile-email">{userInfo.email}</p>

                                    <div className="profile-meta-grid">
                                        <div className="profile-meta-item">
                                            <span className="profile-meta-label">Rol</span>
                                            <span className="profile-meta-value">{userInfo.otherInfo.role}</span>
                                        </div>
                                        <div className="profile-meta-item">
                                            <span className="profile-meta-label">Estado</span>
                                            <span className="profile-meta-value">{userInfo.otherInfo.status}</span>
                                        </div>
                                        <div className="profile-meta-item">
                                            <span className="profile-meta-label">Fecha de ingreso</span>
                                            <span className="profile-meta-value">{userInfo.otherInfo.joinedDate}</span>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <section className="profile-cards">
                                <article className="profile-card card-enterprises">
                                    <h2 className="profile-card-title">Empresas Asociadas</h2>
                                    <ul className="profile-list">
                                        {userInfo.empresasAsociadas.map((empresa, index) => (
                                            <li key={index}>{empresa}</li>
                                        ))}
                                    </ul>
                                </article>

                                <article className="profile-card card-notifications">
                                    <h2 className="profile-card-title">Notificaciones</h2>
                                    <ul className="profile-list">
                                        {userInfo.notifications.map((notification, index) => (
                                            <li key={index}>{notification}</li>
                                        ))}
                                    </ul>
                                </article>

                                <article id="timezone-settings" ref={timezoneSectionRef} className="profile-card card-timezone">
                                    <h2 className="profile-card-title">Zona Horaria</h2>
                                    <label htmlFor="timezone-select" className="profile-field-label">
                                        Selecciona tu zona horaria
                                    </label>
                                    <Select
                                        inputId="timezone-select"
                                        options={timeZoneOptions}
                                        value={selectedTimeZoneOption}
                                        styles={timezoneSelectStyles}
                                        onChange={(selectedOption) => {
                                            if (selectedOption?.value) {
                                                setSelectedTimeZone(selectedOption.value);
                                            }
                                        }}
                                        placeholder="Buscar zona horaria..."
                                        isSearchable
                                        maxMenuHeight={250}
                                    />
                                    <p className="profile-helper">
                                        Hora actual en la zona seleccionada: {currentTimePreview}
                                    </p>
                                </article>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyProfile;
